import { marked } from 'marked';

export const MarkdownRenderer = ({ markdown }: { markdown: string }) => {
	const parsedMarkdown = marked(markdown);
	return <div dangerouslySetInnerHTML={{ __html: parsedMarkdown }}></div>;
};
